import { Button } from '@commenda/kakashi';
import { useBillingContext } from '../context';
import { BookACallLinkByBillingSource } from '../utils';

export const BookACallCard = () => {
  const { internalBillingSource } = useBillingContext();
  return (
    <div className="flex flex-col gap-4 p-6 border border-primary rounded-lg">
      <p className="txt-small-regular text-fg-primary">
        Have any questions? <br /> Schedule a call with one of our experts.
      </p>
      <Button
        variant="secondary"
        onClick={() =>
          window.open(
            BookACallLinkByBillingSource(internalBillingSource),
            '_blank'
          )
        }
      >
        Book a call
      </Button>
    </div>
  );
};
